export default {
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  appBadge(state) {
    return state.appBadge;
  },
  notificationActive(state) {
    return state.settings.notification;
  },
  appLoading(state) {
    return state.appLoading;
  },
  appLoadingLabel(state) {
    return state.appLoadingLabel;
  },
  appBottomSheet(state) {
    return state.appBottomSheet;
  },
  baseUrl() {
    const origin = globalThis.location.origin;
    const pathname = globalThis.location.pathname;
    return `${origin}${pathname}#`;
  },
};
